import { createSelector } from 'reselect';
import { getMachineOperationalStatus } from './getMachineOperationalStatus';
import { getWaitingForWorkEnabled } from './getWaitingForWorkEnabled';

export const getMachineOperationalStatusSinceIndicator = createSelector(
  [getMachineOperationalStatus, getWaitingForWorkEnabled],
  (machineOperationalStatus, waitingForWorkEnabled) => {
    return waitingForWorkEnabled && machineOperationalStatus?.since;
  }
);
